import { BillingStatus as BillingStatusModule } from 'common';
import React from 'react';

const { BillingStatus } = BillingStatusModule;

const BillingStatusWrapper = () => (
	<div className="billing-status-wrapper">
		<BillingStatus />
	</div>
);

export default BillingStatusWrapper;
